import { requests } from '../../../api/agent'

export default {
    createNews: (params) => requests.post(`/news/createNews`,params),
    getNews: (params) => requests.getWithParams(`/news/getNews`,params),
    getOneNews:(params)=> requests.getWithParams('/news/getOneNews',params),
    changeNews: (params)=> requests.post('/news/changeNews',params),
    deleteNews: (params)=> requests.getWithParams('/news/deleteNews',params),
    sendFile: (params) => requests.postForm(`/news/addNewsFile`,params),
    sendFiles: (params) => requests.post(`/news/addNewsFiles`,params),
    downloadNewsFile: (params) => requests.getFile(`/news/downloadNewsFile`, params)
}